import React, { useContext, useState, useRef } from 'react'
import './HackathonBox.css'
import { MainContext } from '../ContextStore/MainContext'


export default function HackathonBox() {
    const { setSelectedHackathon } = useContext(MainContext)
    const [isMouseDown, setIsMouseDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const containerRef = useRef(null);

    const onMouseDown = (e) => {
        setIsMouseDown(true);
        setStartX(e.clientX - containerRef.current.offsetLeft);
        setScrollLeft(containerRef.current.scrollLeft);
    };

    const onMouseLeave = () => {
        setIsMouseDown(false);
    };

    const onMouseUp = () => {
        setIsMouseDown(false);
    };

    const onMouseMove = (e) => {
        if (!isMouseDown) return;
        const x = e.clientX - containerRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        containerRef.current.scrollLeft = scrollLeft - walk;
    };
    const data = [
        {
            image: '/hackathon_banner1.jpg',
            title: 'Food Industry Domain Challenge',
            subTitle: 'Power BI Contest',
            description: "Analyse historical feedback data and provide insights to the marketing team in Food & Beverage industry through Power BI",
            datasets: ["Dim_Customers.csv", "Dim_Geography.csv", "Dim_Menu_Items.csv", "Fact_order_Details.csv"],
            hackathonLink: "https://www.datavizon.com/course/HackathonChallenge-1PowerBiDashboardContent-72847"
        },
        {
            image: '/hackathon_banner2.jpg',
            title: 'Indian Box Office Challenge',
            subTitle: 'Power BI Contest',
            description: 'Analyze trends, unearth concealed insights and craft visually compelling narratives of Indian Box Office through Power BI',
            datasets: ["Boxoffice_fact.csv", "Director_dim.csv", "Genere_dim.csv", "Language_dim.csv"],
            hackathonLink: "https://www.datavizon.com/course/DataHackathon-2IndiaBox-officeCollectionAnalysis-79302"
        },
        {
            image: '/hackathon_banner3.jpg',
            title: 'REAL ESTATE ANALYTICS CHALLENGE',
            subTitle: 'Power BI Contest',
            description: 'Analyze trends, unearth concealed insights and craft visually compelling narratives of real estate firm through Power BI',
            datasets: ["Real_Estate_fact.csv", "City_dim.csv", "Property_type_dim.csv", "State_dim.csv"],
            hackathonLink: "https://www.datavizon.com/course/DataHackathon-2RealestateAnalyticsChallenge-84824"
        },
        {
            image: '/hackathon_banner4.jpg',
            title: 'EVENT MANAGEMENT CHALLENGE',
            subTitle: 'Power BI Contest',
            description: 'Unlock the power of 8+ years of event data from across India in this one-of-a-kind analytics challenge.',
            datasets: ["Events_Data_fct.csv", "Category_dim.csv", "City_dim.csv", "State_dim.csv","Organizer_dim.csv","Venue_dim.csv"],
            hackathonLink: "https://www.datavizon.com/course/DataHackathon-4EventManagementChallange-96807"
        }
    ]
    return (
        <div className='hackathonBoxesContainer allDatasets' ref={containerRef}
            onMouseDown={onMouseDown}
            onMouseLeave={onMouseLeave}
            onMouseUp={onMouseUp}
            onMouseMove={onMouseMove}>
            {
                data?.map((e, id) => {
                    return (
                        <div key={id} className='hackathonBox'>
                            <div className='hackathonImage'>
                                <img src={e.image} alt='hackathonImage' className="hackathon_box_image"></img>
                                <div className='hackathon_box_content'>
                                    <p className="hackathon_box_title">{e.title}</p>
                                    <p className="hackathon_box_subTitle">{e.subTitle}</p>
                                    <p className="hackathon_box_description">{e.description}</p>
                                    <p className="hackathon_box_dataset_heading">Data Set</p>
                                    <div className='hackathon_box_datasets'>
                                        {
                                            e?.datasets?.map((dataset, index) => {
                                                return (
                                                    <p key={index} onClick={() => {
                                                        window.open(e.hackathonLink, "_blank")
                                                    }}>{dataset}</p>
                                                )
                                            })
                                        }
                                    </div>
                                    <p
                                        className='view_winners_button'
                                        onClick={() => {
                                            setSelectedHackathon(`hackathon${id + 1}`);

                                            setTimeout(() => {
                                                const section = document.getElementById('hackathonWinnersSection');

                                                if (section) {
                                                    section.scrollIntoView({
                                                        behavior: 'smooth',
                                                        block: 'start',
                                                    });
                                                }
                                            }, 100);
                                        }}
                                    >
                                        View Winners
                                    </p>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}
